import styled from 'styled-components';
import HeaderBackIconSVG from '../../assets/common/header-back.svg';

const HeaderBackIcon = styled(HeaderBackIconSVG as React.SFC<React.SVGProps<SVGSVGElement>>,)`
  width: ${props => props.width || '2.2rem'};
  height: ${props => props.height || '2.2rem'};
`;

export default HeaderBackIcon;
